export default (v, previousValue) => {

  const newValue = v.replace(/[^\d]/g, '').toString().substring(0, 14)
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');

  return newValue;

};



// WEBPACK FOOTER //
// ./src/components/normalize/CNPJNormalize.js